<loading [visible]="loading() || saving()"></loading>

@if(!loading()) {
<app-custom-modal [customTitle]="'Duplicar compañía' + (sourceName ? ': ' + sourceName : '')"
    (closeFunction)="closeFormFunction()" (acceptFunction)="acceptFormFunction()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <p class="text-sm text-neutral-500">
            Se creará una nueva empresa copiando la configuración de la original. Los datos fiscales,
            de contacto y los registros (clientes, productos, documentos...) no se copian.
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-input [autofocus]="true" label="Nombre de la nueva empresa" placeholder="Nombre oficial" type="text"
                [formControlItem]="saveForm.get('name')"></custom-input>

            <custom-input label="CIF" placeholder="A12345678" type="text"
                [formControlItem]="saveForm.get('cif')"></custom-input>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-input label="Email de contacto" placeholder="ejemplo@empresa.com" type="email"
                [formControlItem]="saveForm.get('email')"></custom-input>

            <custom-input label="Código interno" placeholder="ERP-001" type="text"
                [formControlItem]="saveForm.get('code')"></custom-input>
        </div>

        <div class="p-4 rounded-xl border-2 border-dashed border-purple-300 bg-purple-50 flex flex-col gap-3"
            [formGroup]="includeGroup">
            <div class="text-purple-700 font-semibold text-sm">Qué copiar</div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                @for (section of sections; track section.key) {
                <label class="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" [formControlName]="section.key"
                        class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2">
                    <span class="text-sm text-neutral-700">{{ section.label }}</span>
                </label>
                }
            </div>
        </div>

        <div>
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="is_active"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2 transition-all duration-200">
                <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-neutral-700">Empresa activa</span>
                    <span class="text-xs text-neutral-500">
                        Define si la empresa puede operar en el sistema
                    </span>
                </div>
            </label>
        </div>

    </form>
</app-custom-modal>
}
